import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Layout from '@/components/Layout'
import AuthModal from '@/components/AuthModal'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import OTP from '@/pages/OTP'
import Courses from '@/pages/Courses'
import CourseDetail from '@/pages/CourseDetail'
import Videos from '@/pages/Videos'
import VideoDetail from '@/pages/VideoDetail'
import Teachers from '@/pages/Teachers'
import TeacherDetail from '@/pages/TeacherDetail'
import Profile from '@/pages/Profile'
import Settings from '@/pages/Settings'
import Account from '@/pages/settings/Account'
import Security from '@/pages/settings/Security'
import PremiumSettings from '@/pages/settings/Premium'
import Feed from '@/pages/Feed'
import Premium from '@/pages/Premium'
import Payment from '@/pages/Payment'
import Terms from '@/pages/Terms'
import Privacy from '@/pages/Privacy'
import Help from '@/pages/Help'
import Contact from '@/pages/Contact'
import EULA from '@/pages/EULA'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import Saved from '@/pages/Saved'
import VerifyEmail from './pages/VerifyEmail'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

export default function App() {
  return (
    <>
    <ScrollToTop />
    <AuthModal />
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/videos/:id" element={<VideoDetail />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/teachers/:id" element={<TeacherDetail />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/saved" element={<Saved />} />
        <Route path="/settings" element={<Settings />}>
          <Route index element={<Account />} />
          <Route path="security" element={<Security />} />
          <Route path="premium" element={<PremiumSettings />} />
        </Route>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/help" element={<Help />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/eula" element={<EULA />} />
      </Route>
      <Route path="/premium" element={<Premium />} />
      <Route path="/payment/premium/:plan" element={<Payment />} />
      <Route path="/payment/:id" element={<Payment />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/otp" element={<OTP />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
    </>
  )
}
